const Light = {
    components: {
        Form: {
            verticalLabelPadding: '0 0 3px',
            itemMarginBottom: 10,
        },
        Layout: {
            siderBg: '#FFFFFF !important',
            bodyBg: '#FFFFFF',
        },
        Input: {
            borderRadius: 5,
            borderRadiusLG: 5,
            fontSize: 14,
            fontSizeLG: 14,
        },
        Select: {
            borderRadius: 10,
            fontSize: 16,
            colorBorder: '#EBEBEB',
            activeBorderColor: '#3A56DF',
            hoverBorderColor: '#3A56DF',
            optionSelectedBg: '#8CA0FF',
            selectorBg: '#F6F6F6',
            colorBgElevated: '#F6F6F6',
            colorTextQuaternary: '#1F1F1F',
            colorIcon: '#1F1F1F',
            colorTextPlaceholder: '#1F1F1F',
        },
        Button: {
            fontSize: 14,
            colorBgContainer: 'transparent',
            defaultBorderColor: '#313131',
        },
        Segmented: {
            itemColor: '#C1C1C1',
            itemSelectedColor: '#FFFFFF',
            itemHoverBg: '#F6F6F6',
            itemSelectedBg: '#3954D8',
            trackBg: '#F6F6F6',
        },
        Table: {
            cellFontSize: 16,
            cellFontSizeMD: 16,
            cellFontSizeSM: 16,
            borderColor: '#D6D6D6',
            headerBg: '#F6F6F6',
            colorBgContainer: '#F6F6F6',
            stickyScrollBarBg: '#C1C1C1',
        },
        Popover: {
            colorBgElevated: '#F6F6F6',
        },
        Checkbox: {
            colorBgContainer: '#F6F6F6',
            colorBorder: '#D9D9D9',
        },
        Radio: {
            colorBgContainer: '#F6F6F6',
        },
    },
    token: {
        colorPrimary: '#3A56DF',
        colorTextDescription: '#565656',
        colorTextPlaceholder: '#565656',
        colorText: '#1F1F1F',
        fontFamily: 'Titillium Web, sans-serif',
    },
};

export default Light;
